export const getDragStyleByDevices = ({ isMobile, branding }) => {
  return isMobile
    ? {
        position: "sticky",
        top: "1px",
        left: 0,
        width: "100%",
        zIndex: 1500,
        backgroundColor: branding.dragBarColor,
        borderColor: branding.dragBarColor,
        color: "white",
        borderRadius: "0",
      }
    : {
        cursor: "move",
        position: "sticky",
        top: 0,
        backgroundColor: branding.dragBarColor,
        borderColor: branding.dragBarColor,
        padding: "5px",
        width: "100%",
        zIndex: 10,
        borderTopLeftRadius: "10px",
        borderTopRightRadius: "10px",
      };
};
